import { SignIn } from "features/SignIn";
import { AuthLayout } from "layouts/AuthLayout";
import { FC } from "react";

const SignInPage: FC = () => {
  return (
    <AuthLayout>
      <SignIn />
    </AuthLayout>
  );
};

export default SignInPage;
